export default __webpack_public_path__ + "static/media/arrowRightBlack.565007b3.svg";